module.exports = __webpack_public_path__ + "img/img_41@2x.2253a50b.png";